<script>
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { http } from "../../../helpers/easyindustriaapi/config";
import { listEstados } from "../../../components/defaults/estados.js";
import Swal from "sweetalert2";
import { BFormCheckbox } from "bootstrap-vue";

export default {
  page: {
    title: "Alterar Empresa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: {
    currentEmpresa: {},
    oldEmpresa: { type: Object },
    ibge: { type: Array },
    array_certificados: { type: Array },
  },
  components: {
    Multiselect,
    BFormCheckbox,
  },
  data() {
    return {
      certificados:[],
      select_ambiente:null,
      select_emp_uf:null,
      select_regime_trib:null,
      select_municipio:null,
      abr_certificado: false,
      array_uploads: [],
      certificado: {
        razao_social: null,
      },
      certificado_bol: false,
      password: null,
      file: null,
      razao: null,
      uf: null,
      editando: false,
      titleBody: "Alterar Empresa",
      list2_cfop: ["one", "two", "tree"],
      tipos: [
        {
           id:1,
           nome:"Produção"

        },
        {
           id:2,
           nome:"Homologação"
        },
      ],
      regimes: [
        {
          id: 1,
          nome: "Simples Nacional",
        },
        {
          id: 2,
          nome: "Simples Nacional - excesso de sublimite da receita bruta",
        },
        {
          id: 3,
          nome: "Regime Normal",
        },
      ],
      estados: [],
      diretorio: null,
      empresa:null,
      cidadesIBGE: [],
      listEstados: listEstados,
    };
  },
  created() {
    this.empresa = {
      ...this.oldEmpresa,
      nfe_ind_sinc: Boolean(Number(this.oldEmpresa?.nfe_ind_sinc ?? 0)),
      manifesto_ultimo_nsu: this.oldEmpresa?.manifesto_ultimo_nsu || '000000000000000',
      manifesto_filtro_emitente: Number(this.oldEmpresa?.manifesto_filtro_emitente ?? 1),
    };
    this.$emit("newTitle", this.titleBody);
  },
  async mounted() {
    await this.carregarCertificadosDaEmpresa();

    if (this.empresa && this.empresa.uf) {
      this.select_emp_uf = this.listEstados.find((item) => item.uf === this.empresa.uf) || null;
      if (this.select_emp_uf) {
        await this.cidades_ibge(this.select_emp_uf);
      }
    }

    this.select_ambiente = this.tipos.find((item) => item.id === this.empresa.uhomprod) || null;
    if (this.select_ambiente) {
      this.certificado.uhomprod = this.select_ambiente.id;
    }

    this.select_regime_trib = this.regimes.find((item) => item.id === this.empresa.crt) || null;

    if (this.cidadesIBGE.length > 0) {
      this.select_municipio = this.cidadesIBGE.find((item) => item.id == this.empresa.cidade_id) || null;
    }
  },
  methods: {
    async carregarCertificadosDaEmpresa() {
      const empresaId = this.currentEmpresa?.id || this.empresa?.id;
      if (!empresaId) {
        this.certificados = [];
        this.diretorio = null;
        this.password = null;
        return;
      }

      try {
        const response = await http.get("/nfe/getupload?empresa_id=" + empresaId);
        if (response.status === 200) {
          this.certificados = Array.isArray(response.data) ? response.data : [];
          if (this.certificados.length > 0) {
            this.diretorio = this.certificados[0].nome;
            this.password = this.certificados[0].password || null;
          } else {
            this.diretorio = null;
            this.password = null;
          }
        }
      } catch (error) {
        console.error("Erro ao carregar certificados:", error);
        this.certificados = [];
        this.diretorio = null;
        this.password = null;
        const data = error.response?.data;
        this.makeToast(
          "danger",
          data?.message || "Não foi possível carregar o certificado da empresa."
        );
      }
    },
    seleciona_tp_ambiente(event){
      this.certificado.uhomprod = event.id
      this.empresa.uhomprod = event.id
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      // console.log(this.file);
      
      // console.log(this.file.name);
    },
    async uploadFile() {
      if (!this.file) {
        this.makeToast("danger", "Selecione o arquivo do certificado digital.");
        return;
      }

      if (!this.password) {
        this.makeToast("danger", "Informe a senha do certificado digital.");
        return;
      }

      const uhomprod =
        this.certificado.uhomprod ??
        this.empresa?.uhomprod ??
        this.select_ambiente?.id ??
        null;

      if (![1, 2].includes(Number(uhomprod))) {
        this.makeToast(
          "danger",
          "Selecione o Tipo de Ambiente (Homologação/Produção) antes de enviar o certificado."
        );
        return;
      }

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("password", this.password);
      this.certificado.razao_social = this.currentEmpresa.razao;
      this.certificado.uf = this.currentEmpresa.uf;
      this.certificado.cnpj = this.currentEmpresa.cnpj;
      this.certificado.uhomprod = Number(uhomprod);
      formData.append("razao", this.certificado.razao_social);
      formData.append("uf", this.certificado.uf);
      formData.append("cnpj", this.certificado.cnpj);
      formData.append("uhomprod", this.certificado.uhomprod);
      formData.append("empresa_id", this.currentEmpresa.id);
      this.abr_certificado = false;

      try {
        const response = await http.post("/nfe/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status == 200) {
          this.makeToast("success", "Certificado enviado com sucesso");
          await this.carregarCertificadosDaEmpresa();
        }
        setTimeout(() => {
          this.abr_certificado = true;
        }, 1000);
      } catch (error) {
        console.error("Erro no upload:", error);
        this.abr_certificado = true;
        this.makeToast("danger", this.extractUploadErrorMessage(error));
      }
    },
    extractUploadErrorMessage(error) {
      const data = error.response?.data;
      if (!data) {
        return error.message || "Não foi possível enviar o certificado.";
      }
      if (typeof data === "string") {
        return data;
      }
      if (data.message) {
        return data.message;
      }
      const firstError = Object.values(data)[0];
      if (Array.isArray(firstError)) {
        return firstError[0];
      }
      if (typeof firstError === "string") {
        return firstError;
      }
      return "Não foi possível enviar o certificado. Verifique os dados e tente novamente.";
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    handleFileChange(event) {
      // Atualiza a variável 'diretorio' com o nome do arquivo selecionado

      this.diretorio = event.target.files[0].name;
      this.empresa.nome_certificado = this.diretorio // não precisa desses dois é so fazer um relacionamento com a table uploadas
      this.empresa.password = this.password
      this.file = event.target.files[0];
      console.log(this.diretorio);
      console.log(this.currentEmpresa);
      console.log(this.password);
      //console.log(this.diretorio)
    },
    async post_enviar(event) {
      event.preventDefault();

      let certificado = this.file;
      certificado.empresa_id = this.currentEmpresa.id;
      certificado.user_id = this.currentUser.id;
      //console.log(banco);
      this.onLoader();

      try {
        let response = await http.post(
          "/certificado?empresa_id=" + this.currentEmpresa.id,
          certificado
        );
        if (response) {
          this.offLoader();
          if (response.status === 200) {
            this.getData();
            this.inserindo = false;
            this.makeToast("success", "certificado incluído");
          }
        }
      } catch (error) {
        this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast("danger", "Destino URL não encontrado!");
          } else {
            this.makeToast("danger", error);
          }
        }
      }
    },
    convert_citys() {
      this.ibge.forEach((cidade) => {
        console.log(cidade.municipio);
        this.adicionarSemDuplicatas(
          (cidade.municipio && cidade.municipio.microrregiao.mesorregiao) ? cidade.municipio.microrregiao.mesorregiao.UF : null
        );
      });
    },
    adicionarSemDuplicatas(novoObjeto) {
      if (!this.estados.some((objeto) => objeto.nome === novoObjeto.nome)) {
        this.estados.push(novoObjeto);
      }
    },
    setNewTitle() {
      this.$emit("newTitle", "Alterar Empresa " + this.empresa.id);
    },
    setPut() {
      this.empresa.pathenvio = 'NULL';
      this.empresa.pathretorno = 'NULL';
      this.empresa.pathxml = 'NULL';
      this.empresa.chave_comunicacao = 'NULL';
      this.$emit("doPut", {
        ...this.empresa,
        nfe_ind_sinc: Number(this.empresa.nfe_ind_sinc),
      });
    },
    get_ibge() {},
    async select_cidade_por_uf(objeto) {
      this.empresa.uf = objeto.uf;
      this.empresa.uf_id = objeto.id;
      
      // Buscar as cidades do IBGE para o estado selecionado
      try {
        Swal.fire({
          title: "Carregando cidades",
          text: "Aguarde um momento...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        await this.cidades_ibge(objeto);
      } catch (error) {
        console.error("erro ao carregar cidades:", error);
      } finally {
        Swal.close();
      }
    },
    seleciona_cod_nome_municipio(event) {
      this.empresa.cidade = event.nome;
      this.empresa.cidade_id = event.id;
    },
    async cidades_ibge(objeto) {
      let uf = objeto.uf;

      try {
        // bug , aqui , pois não da para pesquisar por emepresa_id
        // e  só consigo fazer o get por id ou estado ou nome ;
        let response = await http.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
        );

        if (response.status === 200) {
          this.cidadesIBGE = response.data.sort((a, b) => a.nome.localeCompare(b.nome));
        }
      } catch (error) {
        console.error("erro ao buscar cidades:", error);
        let messageErro = error.response?.data;

        if (error.response) {
          switch (error.response.status) {
            case 406:
              this.makeToast(
                "danger",
                "Erro 406: " + (messageErro?.tipo
                  ? messageErro.tiponome
                  : messageErro?.tpag || "Erro desconhecido")
              );
              break;
            case 404:
              this.makeToast(
                "danger",
                "Erro 404: endpoint não encontrado ou servidor fora do ar"
              );
              break;
            default:
              this.makeToast("danger", error.message || "Erro desconhecido");
              break;
          }
        } else {
          this.makeToast("danger", "Erro de conexão: " + error.message);
        }
      }
    },
    seleciona_regime_trib(objeto) {
      this.empresa.crt = objeto.id;
    },
    carregar_certificado() {
      // colocar o link do endpint aqui;
    },
    voltar() {
      this.$emit("back");
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="accordion" role="tablist">
      <form role="form" class="form-horizontal">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-dados-gerais variant="light"
              >Informações da empresa</b-button
            >
          </b-card-header>
          <b-collapse
            id="pedido-dados-gerais"
            visible
            accordion="pedido-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-2" id="cod_prod">
                  <div class="form-group">
                    <label for="empresa_id" class="col-form-label"
                      >Código interno</label
                    >
                    <div class="col">
                      <input
                        disabled
                        class="form-control text-right"
                        type="text"
                        placeholder="Gerado pelo sistema"
                        id="empresa_id"
                        v-model="empresa.id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3">
                  <div class="form-group" id="espaco1">
                    <label for="quatidade_id" class="col-form-label"
                      >CNPJ</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.cnpj"
                        type="number"
                        class="form-control text-right"
                        placeholder="Qauntidade"
                        id="quantidade"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-4" id="desc_ID">
                  <div class="form-group">
                    <label for="empresa_nome" class="col-form-label">Apelido</label>
                    <div class="col">
                      <input
                        class="form-control text-left"
                        type="text"
                        placeholder="Digite o apelido da empresa"
                        id="empresa_nome"
                        v-model="empresa.apelido"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4" id="desc_ID">
                  <div class="form-group">
                    <label for="empresa_fantasia" class="col-form-label">Nome fantasia</label>
                    <div class="col">
                      <input
                        class="form-control text-left"
                        type="text"
                        placeholder="Digite o nome fantasia da empresa"
                        id="empresa_fantasia"
                        v-model="empresa.fantasia"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4">
                  <div class="form-group">
                    <label for="razao_id" class="col-form-label" id="CFOP_ID"
                      >Razão Social</label
                    >
                    <div class="col" id="CFOP_ID">
                      <input
                        v-model="empresa.razao"
                        class="form-control"
                        type="text"
                        placeholder="digite a razão social"
                        id="razao_id"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group" id="espaco">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="endereco" class="col-form-label"
                      >Endereço
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.endereco"
                        class="form-control"
                        placeholder="Digite o endereço"
                        id="endereco_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="bairro" class="col-form-label">Bairro</label>
                    <div class="col">
                      <input
                        v-model="empresa.bairo"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o bairro"
                        id="bairro_id"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="numero" class="col-form-label">Número</label>
                    <div class="col">
                      <input
                        v-model="empresa.numero"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o número"
                        id="numero_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="complemento" class="col-form-label"
                      >Complemento</label
                    >
                    <div class="col">
                      <input 
                        v-model="empresa.complemento"
                        type="text"
                        class="form-control text-left"
                        placeholder="Digite o complemento"
                        id="complemento_id"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_telefone" class="col-form-label"
                      >Telefone</label
                    >
                    <div class="col">
                      <input
                       v-model="empresa.fone"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o telefone"
                        id="empresa_telefone"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_cep" class="col-form-label">C.E.P.</label>
                    <div class="col">
                      <input
                        v-model="empresa.cep"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o CEP"
                        id="empresa_cep"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="empresa_uf" class="col-form-label">Estado (UF)</label>
                    <div class="col">
                      <Multiselect id="empresa_uf"
                        v-model="select_emp_uf"
                        :options="listEstados"
                        :close-on-select="true"
                        label="nome"
                        track-by="uf"
                        value-prop="uf"
                        placeholder="Estado"
                        @select="select_cidade_por_uf($event)"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-5">
                  <div class="form-group">
                    <label for="empresa_cidade" class="col-form-label">Cidade</label>
                    <div class="col">
                      <Multiselect
                        v-model="select_municipio"
                        :options="cidadesIBGE"
                        label="nome"
                        track-by="id"
                        @select="seleciona_cod_nome_municipio($event)"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="insc_estadual" class="col-form-label"
                      >Inscrição Estadual</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.ie"
                        type="text"
                        class="form-control"
                        placeholder="Digite a inscrição estadual"
                        id="insc_estadual_id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="insc_municipal" class="col-form-label"
                      >Inscrição Municipal
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.im"
                        type="text"
                        class="form-control"
                        placeholder="Digite a inscrição municipal"
                        id="insc_municipal_id"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
          <!-- Menus de Impostos-->

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-complementares variant="light"
              >Dados NF-e</b-button
            >
          </b-card-header>
          <b-collapse id="pedido-complementares">
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="chave_comunicacao" class="col-form-label"
                      >Chave de acesso</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="chave_comunicacao"
                        v-model="empresa.chave_comunicacao"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="Origem" class="col-form-label"
                      >Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.tokensefaz"
                        type="text"
                        class="form-control text-left"
                        id="CSOSN"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="tk_sefaz" class="col-form-label"
                      >ID Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.idtokensefaz"
                        type="text"
                        class="form-control text-left"
                        id="tk_sefaz"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="base_icms" class="col-form-label"
                      >Tipo de Ambiente</label
                    >
                    <div class="col">
                      <Multiselect
                        @select="seleciona_tp_ambiente($event)"
                        :options="tipos"
                        label="nome"
                        track-by="id"
                        v-model="select_ambiente"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label for="Reg_trib" class="col-form-label"
                      >Regime tributário (CRT)</label
                    >
                    <div class="col">
                      <Multiselect
                        :options="regimes"
                        v-model="select_regime_trib"
                        @select="seleciona_regime_trib($event)"
                        label="nome"
                        track-by="id"
                      >                        
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="nfe-ind-sinc-edit" class="col-form-label d-block"
                      >Enviar NF-e em modo síncrono</label
                    >
                    <b-form-checkbox
                      id="nfe-ind-sinc-edit"
                      v-model="empresa.nfe_ind_sinc"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Enviar NF-e em modo síncrono
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      Desmarque para usar o envio assíncrono (padrão da SEFAZ). Marque apenas quando a UF exigir envio síncrono.
                    </small>
                  </div>
                </div>
              </div>
              <div class="form-row form-group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="manifesto-ultimo-nsu-edit" class="col-form-label"
                      >Último NSU do Manifesto</label
                    >
                    <div class="col">
                      <input
                        id="manifesto-ultimo-nsu-edit"
                        v-model="empresa.manifesto_ultimo_nsu"
                        type="text"
                        maxlength="15"
                        class="form-control text-left"
                      />
                      <small class="form-text text-muted">
                        Atualizado automaticamente após consultas à SEFAZ. Use para configuração inicial ou recuperação.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="manifesto-filtro-emitente-edit" class="col-form-label"
                      >Filtro padrão de emitentes</label
                    >
                    <div class="col">
                      <select
                        id="manifesto-filtro-emitente-edit"
                        v-model.number="empresa.manifesto_filtro_emitente"
                        class="form-control"
                      >
                        <option :value="1">Todos os emitentes</option>
                        <option :value="2">Excluir emitentes do mesmo CNPJ base</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pdv-ipi variant="light2"
              >Certficado</b-button
            >
          </b-card-header>
          <b-collapse id="pdv-ipi">
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="s_tributaria" class="col-form-label"
                      >Carregar Certificado no Computador</label
                    >
                    <div class="col">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="customFile"
                          @change="handleFileChange($event)"
                        />

                        <label class="custom-file-label" for="customFile">{{
                          diretorio || "Selecione o Certificado"
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="cod_enq" class="col-form-label"
                      >Carregar Certificado no sistema</label
                    >
                    <div class="col">
                      <button
                        class="btn btn-light"
                        @click.prevent="uploadFile()"
                      >
                        Carregar
                      </button>
                      <button class="btn btn-light ml-2 mr-2">
                        Ler configurações
                      </button>
                      <button class="btn btn-light">Status</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="certificado" class="col-form-label"
                      >Senha</label
                    >
                    {{password}}
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="certificado_id"
                        v-model="password"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group"></div>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- engloba  todos-->
      </form>
      <!-- form engloba todos-->
    </div>
    <!--Engloba todos -->
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button class="btn btn-light" @click="setPut()">Alterar Empresa</button>
      </div>
    </div>
  </div>
</template>